import { useEffect, useState } from "react";
import AppShell, { type RouteKey } from "./components/AppShell";
import Dashboard from "./features/dashboard/Dashboard";
import Monitoring from "./features/monitoring/Monitoring";
import Execution from "./features/execution/Execution";
import SettingsView from "./features/settings/SettingsView";
import Plans from "./features/plans/Plans";
import Alerts from "./features/alerts/Alerts";
import SystemHealth from "./features/health/SystemHealth";
import { getChartSettings } from "./data/api";
import { applyFontPreference, defaultFontStack } from "./data/fonts";

const defaultRoute: RouteKey = "dashboard";

function routeFromHash(): RouteKey {
  const route = window.location.hash.replace("#", "") as RouteKey;
  return ["dashboard", "monitoring", "plans", "execution", "alerts", "settings", "health"].includes(route) ? route : defaultRoute;
}

export default function App() {
  const [route, setRoute] = useState<RouteKey>(() => routeFromHash());

  useEffect(() => {
    applyFontPreference(defaultFontStack);
    getChartSettings()
      .then((settings) => applyFontPreference(settings.ui.fontFamily))
      .catch(() => applyFontPreference(defaultFontStack));
  }, []);

  useEffect(() => {
    const onHashChange = () => setRoute(routeFromHash());
    window.addEventListener("hashchange", onHashChange);
    return () => window.removeEventListener("hashchange", onHashChange);
  }, []);

  const changeRoute = (nextRoute: RouteKey) => {
    window.location.hash = nextRoute;
    setRoute(nextRoute);
  };

  return (
    <AppShell route={route} onRouteChange={changeRoute}>
      {route === "dashboard" && <Dashboard />}
      {route === "monitoring" && <Monitoring />}
      {route === "plans" && <Plans />}
      {route === "execution" && <Execution />}
      {route === "alerts" && <Alerts />}
      {route === "settings" && <SettingsView />}
      {route === "health" && <SystemHealth />}
    </AppShell>
  );
}
